
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[companySubID]",
      function () {
        return require("private-next-pages/[companySubID].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[companySubID]"])
      });
    }
  